module.exports = __webpack_public_path__ + "img/bng4.38f0089f.png";